import { DateTime } from 'luxon'

import moment from 'moment'

import numeral from 'numeral'

import 'moment/locale/fr'

window.moment = moment;
window.moment.locale('fr');

window.numeral = numeral;
window.numeral.locale('en');

window.DateTime = DateTime;

export default { };